import { memo } from "react";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { useBuilderStore } from "@circle-react-shared/BuilderUI";
import { isAcceptableToDrop } from "@circle-react-shared/BuilderUI/Helpers/droppableAcceptsDraggable";
import type { BlockCategoryName } from "@circle-react-shared/BuilderUI/constants/BlockCategories";

export interface FloatingDropAreaProps {
  accepts: BlockCategoryName[];
  isOver: boolean;
  rejects: BlockCategoryName[];
}

export const FloatingDropArea = memo(
  ({ isOver, accepts, rejects }: FloatingDropAreaProps) => {
    const draggingTemplate = useBuilderStore(state => state.draggingTemplate);

    const categories = draggingTemplate
      ? (draggingTemplate.meta.category ?? [])
      : [];

    const isAcceptable = isAcceptableToDrop({ accepts, categories, rejects });

    return (
      <div
        className={classNames(
          "border-secondary h-full w-full rounded border-2 border-dashed transition-all",
          {
            "bg-blue-400/20 backdrop-blur-sm": isOver && isAcceptable,
            "bg-red-400/20 backdrop-blur-sm": isOver && !isAcceptable,
          },
        )}
        data-testid="floating-drop-area"
      />
    );
  },
);

FloatingDropArea.displayName = "FloatingDropArea";
